import React, {useContext, useEffect} from "react";
import initSettingsSetupMaybeCreateBookable from "../../data/initSettingsSetupMaybeCreateBookable";
import companyTypeEnum from "../../data/companyTypeEnum";
import countryCodes from "../../data/countryCodes";
import AuthContext from "../../context/AuthContext";
import initCompany from "../../data/initCompany";
import {Form, Input, Media, Select, SelectArray, Static} from "../../components/Form/Form";
import {Route, useNavigate} from "react-router-dom";
import WaitingForVerification from "../WaitingFormVerification/WaitingForVerification";
import SocialLoginButtons from "../../components/SocialLoginButtons/SocialLoginButtons";
import SettingCheckboxes from "../../components/Form/SettingCheckboxes";
import useCompanyService from "../../api/services/useCompanyService";
import SelectArrayIcons from "../../components/Form/SelectArrayIcons";
import useUserService from "../../api/services/useUserService";
import useFunction from "../../hooks/useFunction";
import useWizard from "../../hooks/useWizard";
import Register from "../../components/Register/Register";
import useForm from "../../hooks/useForm";
import Address from "../../components/Form/Address";
import Loading from "../../components/Loading/Loading";
import Fields from "../../components/Form/Fields";
import Wizard from "../../layouts/Wizard/Wizard";
import Button from "../../components/Button/Button";
import Login from "../../components/Login/Login";
import spotGroupIcon from "../../assets/icons/spot-group.svg";
import truckIcon from "../../assets/images/truck-icon.png"
import standIcon from "../../assets/icons/stand.svg";
//import './style.scss'
// import IbanMedia from "../../components/Form/IbanMedia";
// import Verified from "../../components/Form/Verified";
// import useValidationIban from "../../hooks/useValidationIban";


function WizardWelcome() {

  const {objIsEmpty} = useFunction()

  const pathname = '/wizard/welkom'
  const steps = [
    {slug: 'start', label: ''},
    {slug: 'choice_login_register'},
    {slug: 'register'},
    {slug: 'register_confirm_email'},
    {slug: 'login'},
    {slug: 'setup_type'},
    {slug: 'company_select'},
    {slug: 'company_new'},
    {slug: 'company_new_extra'},
    // {slug:'company_new_bank'},
    {slug: 'company_new_overview'},
    {slug: 'choice_stand_truck_location'},
  ]

  const initialButtonPrev = {
    start: {
      label: 'Annuleren',
      onClick: () => navigate('/'),
      className: 'btn-color-red',
    },
    register: {},
    register_confirm_email: {},
    login: {
      onClick: () => wizard.goTo('choice_login_register')
    },
    setup_type: {
      label: 'Annuleren',
      onClick: () => navigate('/'),
      className: 'btn-color-red',
    },
    company_select: {
      onClick: () => navigate(-1),
    },
    company_new: {
      onClick: () => navigate(-1)
    },
    company_new_overview: {
      label: "Mijn Standplaats",
      onClick: () => navigate('/user/mijn-standplaats'),
      className: 'btn-color-green'
    },
    choice_stand_truck_location: {
      label: "Annuleren",
      className: 'btn-color-red',
      onClick: () => navigate('/'),
    }
  }
  const initialButtonNext = {
    choice_login_register: {
      visible: false,
    },
    login: {
      visible: false,
    },
    register: {
      visible: false,
    },
    company_select: {
      disabled: true
    },
    setup_type: {
      onClick: () => wizard.goTo('company_select'),
    },
    company_new: {
      visible: false,
    },
    company_new_overview: {
      label: "Doorgaan"
    },
    choice_stand_truck_location: {
      visible: false,
    }
  }

  const updateSteps = (steps) => {
    return steps
  }
  const form = useForm()
  const wizard = useWizard(
    steps,
    updateSteps,
    pathname,
    initialButtonPrev,
    initialButtonNext,
    form,
  )


  const {setUser, user} = useContext(AuthContext)
  const {getToken} = useFunction()
  const navigate = useNavigate()
  const userService = useUserService()
  const companyService = useCompanyService()

  // const {onClickValidateIban} = useValidationIban(wizard.id, form, '/wizard/welkom/company_new_bank/'+wizard.id+'/')


  useEffect(() => {
    //not sure why, but it fixes that buttons are not showing
    if (wizard.step === 'start') {
      form.formData.isLoading = false
      form.save(false)
    }
    if (wizard.step === 'choice_login_register' && getToken()) {
      wizard.goTo('setup_type')
    }
    if (wizard.step === 'login' && getToken()) {
      wizard.goTo('setup_type')
    }

    // if (wizard.step === 'company_new' && objIsEmpty(user)) {
    //   wizard.goTo('login')
    // }

    if (wizard.step === 'setup_type') {
      if (objIsEmpty(user) && !user.settings_all){
        userService.userShow((user) => {
          setUser(user) /* todo test. needed here? update global user state */

          // console.log('TEST useruseruseruser', user)
        })
      }
    }

    if (wizard.step === 'company_select') {

      userService.userShow((user) => {
        setUser(user) /* todo test. needed here? update global user state */
        if (user.active_company_id) {
          wizard.setButtonNext(prevState => {
            return {
              ...prevState,
              company_select: {
                disabled: false,
                onClick: () => wizard.goTo('choice_stand_truck_location'),
              }
            }
          })
        } else {
          wizard.goTo('company_new')
        }
      })
    }
  }, [wizard.step])

  const handleSelectActiveCompany = (user) => {
    if (user.active_company_id) {
      wizard.goTo('choice_stand_truck_location')
    } else {
      wizard.nextButtonDisabled()
    }
  }

  const onResetCompanySelect = () => {
    wizard.setInitialButtons()
  }

  // //todo change/. Same function in WizardWelcome.js and UserCompanyEdit.js
  // const onClickValidate = () => {
  //   swal({
  //     title: 'Let op!',
  //     icon: 'warning', //todo question
  //     text: 'Voorlopig kun je alles doen zonder gevalideerde IBAN. LET OP: Zorg er met absolute zekerheid voor dat het ' +
  //       'IBAN nummer wat hier ingevoerd is klopt! Als Standplaats.nl BV het geld overmaakt naar het verkeerde IBAN account, kunnen' +
  //       'we het geld niet meer terugkrijgen! Het is jouw verandwoordelijkheid om het juiste nummer hier in te voeren.',
  //     buttons: {
  //       confirm: {
  //         text: 'OK',
  //         value: true,
  //         visible: true,
  //         className: 'btn btn-green', //todo werkt nu niet??
  //         closeModel: true,
  //       }
  //     }
  //   })
  // }

  return (
    <div className="wizard-welcome">
      <Wizard
        form={form}
        wizard={wizard}
      >
        <Route path="/start/*" element={
          <div className="welcome-start">
            <div className="welcome-header">
              <h1>Welkom bij Standplaats.nl!</h1>
              <p className="subtitle">In een paar stappen maak je gratis een account aan</p>
            </div>

            <div className="steps-preview">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-text">
                  <strong>Account aanmaken</strong>
                  <span>of inloggen als je er al een hebt</span>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-text">
                  <strong>Accountnaam kiezen</strong>
                  <span>Prive, of bedrijfs- of organisatienaam</span>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-text">
                  <strong>Profiel aanmaken</strong>
                  <span>stand/truck of locatie</span>
                </div>
              </div>
            </div>
          </div>
        }/>

        <Route path="/choice_login_register/*" element={
          <div className="center">
            <h2>Join the club!</h2>
            <div className="width-medium">
              <p>Om boekingsaavragen te doen moet je een gebruikersaccount hebben</p>
              <p>Log in, of als je nog geen gebruikersaccount hebt maken we die nu <span
                className="color-green"><strong>gratis & vrijblijvend</strong></span> aan!
              </p>
              <br/><br/>
              <h3>Ik wil:</h3>
              <div className="buttons">
                <Button
                  label="Account aanmaken"
                  onClick={() => wizard.goTo('register')}
                />
                <Button
                  label="Inloggen"
                  onClick={() => wizard.goTo('login')}
                />
              </div>
              <p>Of login/registreer met 1 klik:</p>
              <SocialLoginButtons/>
            </div>
          </div>
        }/>

        <Route path="/register/*" element={
          <Register
            showLoginButton={false}
          />
        }/>

        <Route path="/register_confirm_email/*" element={
          <WaitingForVerification/>
        }/>

        <Route path="/login/*" element={
          <Login
            showRegisterButton={false}
            updateSuccess={() => wizard.goTo('setup_type')}
          />
        }/>

        <Route path="/setup_type/*" element={
          <div className="setup-type center">
            <h2>Vink aan wat voor jou van toepassing is</h2>
            <p className="reassurance">Je kunt later altijd wijzigingen aanbrengen of extra profielen toevoegen.</p>
            <div className="">
              {/*<p>Het is voor ons belangrijk om te weten wat je wil doen op ons platform en om jou daar zo goed mogelijk*/}
              {/*  bij te helpen, stellen we de nodige vragen:</p>*/}
              {/*<p>- Wil je een locatie aanbieden? -> Kies voor locatie</p>*/}
              {/*<p>- Wil je een stand of truck op het platform zetten? -> Kies voor stand of truck</p>*/}
              {/*<p>- Of weet je het nog niet en wil je eerst op het platform rondkijken en later beslissen? -> Kies voor*/}
              {/*  Gast</p>*/}
              {/*<br/>*/}
              {/*<br/>*/}

              <Form>
                <Fields
                  id={user.id}
                  form={form}
                  wizard={wizard}
                  apiService={userService}
                  updateSuccess={() => wizard.goTo('company_select')}
                  onChange={() => wizard.navButtonsDisabled()}
                  onReset={() => onResetCompanySelect}
                >
                  <SettingCheckboxes
                    name={'settings_all'}
                    setting={'setup_maybe_create_bookable'}
                    data={initSettingsSetupMaybeCreateBookable}
                  />
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/company_select/*" element={
          <div className="center">
            <h2>Account/organisatie of bedrijf?</h2>
            <AuthContext.Consumer>
              {
                ({setUser, user}) => {
                  return (
                    <div className="width-medium">
                      {!('companies' in user) || ('companies' in user && user.companies.length) ?
                        <>
                          <div className="width-small">
                            <Form>
                              <Fields
                                id={user.id}
                                form={form}
                                wizard={wizard}
                                apiService={userService}
                                updateSuccess={handleSelectActiveCompany}
                                onChange={() => wizard.navButtonsDisabled()}
                                onReset={() => onResetCompanySelect}
                              >
                                <Select
                                  label="Selecteer account/organisatie:"
                                  name="active_company_id"
                                  relation="companies"
                                  relationLabel="legal_name"
                                />
                              </Fields>
                            </Form>
                          </div>
                          <h3>Of:</h3>
                        </>
                        :
                        <>
                          <Loading/>
                          <p>Je hebt nog geen account, organisatie of bedrijf gekoppeld aan deze gebruiker.</p>
                          <p><strong>Jouw account naam, of bedrijf/organisatie naam is straks overal zichtbaar: op alle
                            profielen, verzoeken,
                            berichten..</strong></p>
                        </>
                      }
                    </div>
                  )
                }
              }
            </AuthContext.Consumer>
            <Button
              onClick={() => wizard.nextStep()}
              label="Nieuwe Account naam of nieuwe organisatie/bedrijf aanmaken"
              color="grey-ghost"
            />
          </div>
        }/>

        <Route path="/company_new/*" element={
          <>
            {!objIsEmpty(user) ?
              <div className="center">
                <h2>Account naam</h2>
                <p>Op standplaats.nl kunnen andere gebruikers jou herkennen aan een account naam! Dit kan bijvoorbeeld
                  je bedrijfsnaam zijn, de naam van de stichting of zoiets als 'de groentebroers'.</p>
                <p>Je kan meerdere gebruikers (e-mailadressen) onder 1 account-naam hangen.</p>
                <br/>
                <div className="width-medium">
                  <Form>
                    <Fields
                      initData={initCompany}
                      form={form}
                      wizard={wizard}
                      apiService={companyService}
                      updateSuccess={(company) => wizard.nextStep(company.id)}
                      onChange={() => wizard.navButtonsDisabled()}
                      onReset={() => onResetCompanySelect}
                    >
                      <SelectArrayIcons
                        label="Type account:"
                        name="type"
                        data={companyTypeEnum}
                      />

                      {/*Conditional show legal_name field*/}
                      <Input
                        label="Account Naam"
                        name="legal_name"
                        autoFocus="autofocus"
                        placeholder="Voorbeeld: De groentebroers"
                        disabled={form.formData.model.is_verified}
                        enabledBy={[{key: 'type', value: 'non-official'}]}
                      />
                      <Input
                        label="Officiële bedrijfs naam"
                        name="legal_name"
                        autoFocus="autofocus"
                        placeholder="Voorbeeld: Standplaats.nl BV"
                        disabled={form.formData.model.is_verified}
                        enabledBy={[{key: 'type', value: 'commercial'}]}
                      />
                      <Input
                        label="Organisatie naam"
                        name="legal_name"
                        autoFocus="autofocus"
                        placeholder="Voorbeeld: Gemeente Utrecht"
                        disabled={form.formData.model.is_verified}
                        enabledBy={[{key: 'type', value: 'public'}]}
                      />
                      <Input
                        label="Organisatie naam"
                        name="legal_name"
                        autoFocus="autofocus"
                        placeholder="Voorbeeld: Stichting Verse groente"
                        disabled={form.formData.model.is_verified}
                        enabledBy={[{key: 'type', value: 'non-profit'}]}
                      />
                      {/* end conditional show legal_name field*/}


                      <Input
                        label="BTW Nummer (alleen invullen als deze organisatie BTW plichtig is)"
                        name="vat_number"
                        disabledBy={[{key: 'type', value: 'non-official'}]}
                      />
                      <Input
                        label="KVK Nummer"
                        name="coc_number"
                        disabled={form.formData.model.coc_number_verified_at}
                        disabledBy={[{key: 'type', value: 'non-official'}]}
                      />
                      <SelectArray
                        label="Land"
                        name="country_code"
                        data={countryCodes}
                        disabledBy={[{key: 'type', value: 'non-official'}]}
                      />
                    </Fields>
                  </Form>
                </div>
              </div>
              :
              <Login
                showRegisterButton={false}
                updateSuccess={() => navigate('/wizard/welkom/company_new')}
              />
            }
          </>

        }/>

        <Route path="/company_new_extra/*" element={
          <div className="center">
            <h2>Account/organisatie/bedrijf gegevens</h2>
            <div className="width-small">
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={companyService}
                  updateSuccess={() => wizard.nextStep()}
                  onChange={() => wizard.navButtonsDisabled()}
                  onReset={() => wizard.setInitialButtons()}
                >
                  <Input
                    label="Telefoonnummer"
                    name="phone"
                    autoFocus="autofocus"
                    disabledBy={[{key: 'type', value: 'non-official'}]}
                  />
                  <Media
                    label="Logo"
                    name="logo_media"
                    width={120}
                    height={120}
                    size="logo"
                  />
                  <Address
                    label="Organisatie/bedrijf adres"
                    text="Het adres waar je organisatie berijkbaar is."
                    name="address"
                    disabledBy={[{key: 'type', value: 'non-official'}]}
                  />

                  {/*<MultiBlock*/}
                  {/*  label="Gebruikers"*/}
                  {/*  name="users"*/}
                  {/*  keyLabel="email"*/}
                  {/*  confirmDelete="Word pas echt verwijderd nadat u op OPSLAAN geklikt heeft, onderaan deze pagina"*/}
                  {/*/>*/}
                  {/*<AddMultiBlock*/}
                  {/*  label="Gebruiker toevoegen aan deze organisatie"*/}
                  {/*  name="users"*/}
                  {/*  keyLabel="email"*/}
                  {/*  type="email"*/}
                  {/*  placeholder="Email van gebruiker"*/}
                  {/*  confirmAdd="U staat op het punt om %s volledige toegang te verleden tot deze organisatie."*/}
                  {/*/>*/}
                </Fields>
              </Form>
            </div>
          </div>
        }/>


        {/*<Route path="/company_new_bank/*" element={*/}
        {/*  <div className="center">*/}
        {/*    <h2>Bankgegevens</h2>*/}
        {/*    <div className="width-medium">*/}
        {/*      <Form>*/}
        {/*        <Fields*/}
        {/*          id={wizard.id}*/}
        {/*          form={form}*/}
        {/*          wizard={wizard}*/}
        {/*          apiService={companyService}*/}
        {/*          updateSuccess={() => wizard.nextStep()}*/}
        {/*          onChange={() => wizard.navButtonsDisabled()}*/}
        {/*          onReset={() => wizard.setInitialButtons()}*/}
        {/*        >*/}
        {/*          <IbanMedia*/}
        {/*            name="iban_media"*/}
        {/*            width={900}*/}
        {/*            size="normal_full_height"*/}
        {/*            id={wizard.id}*/}
        {/*          />*/}
        {/*<Input*/}
        {/*  label="IBAN account nummer"*/}
        {/*  // placeholder="NL99BANK0000000000"*/}
        {/*  name="iban_number"*/}
        {/*  disabled={true}*/}
        {/*/>*/}
        {/*<Input*/}
        {/*  label="IBAN tenaamstelling"*/}
        {/*  name="iban_holder_name"*/}
        {/*  disabled={true}*/}
        {/*/>*/}
        {/*        </Fields>*/}
        {/*      </Form>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*}/>*/}

        <Route path="/company_new_overview/*" element={
          <div className="center">
            <h2>Gefeliciteerd, je account is aangemaakt!</h2>
            <div className="width-small">
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={companyService}
                  onChange={() => wizard.navButtonsDisabled()}
                  onReset={() => onResetCompanySelect}
                >
                  <Static
                    label="Accountnaam"
                    name="legal_name"
                  />
                  <p>Nu kun je vanuit dit account/deze organisatie:</p>
                  <ul>
                    <li>Stands of trucks huren of verhuren</li>
                    <li>Locaties huren of verhuren</li>
                    <li>Berichten versturen</li>
                  </ul>
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/choice_stand_truck_location/*" element={
          <div className="choice-stand-truck-location center">
            <h2>Klaar! Wat nu?</h2>
            <br/>
            <h2>Maak een profiel aan:</h2>
            <div className="">
              <div className="items">
                <div className="item">
                  <img width={70} src={standIcon} alt="stand"/>
                  <div className="center">
                    <Button
                      label="Aanmaken: Stand of truck"
                      link="/wizard/stand/start"
                      linkState={{buttonPrev: {new: {onClick: {navigate: '/wizard/welkom/choice_stand_truck_location/'}}}}}
                    />
                  </div>
                  <br/>
                  <ul className="color-grey">
                    <div>Stands, trucks</div>
                    <div>acts</div>
                    <div>mobiele ondernemers</div>
                    <div>ambulante handelaren</div>
                  </ul>
                  <br/>
                  <br/>
                </div>
                <div className="item">
                  <img width={70} src={spotGroupIcon}/>
                  <div className="center">
                    <Button
                      label="Aanmaken: Locatie"
                      link="/wizard/locatie/start"
                      linkState={{buttonPrev: {new: {onClick: {navigate: '/wizard/welkom/choice_stand_truck_location/'}}}}}
                    />
                  </div>
                  <br/>
                  <ul className="color-grey">
                    <div>Markten</div>
                    <div>Evenementen</div>
                    <div>Winkels</div>
                    <div>Bedrijventerreinen</div>
                  </ul>
                  <br/>
                  <br/>
                </div>
              </div>
              <h2>Of, bekijk eerst onze profielen:</h2>
              <div className="items">
                <div className="item">
                  <img width={70} src={spotGroupIcon} alt="locatie"/>
                  <div className="center">
                    <Button
                      label="Bekijk de Locaties!"
                      link="/?search_model=spot_group"
                      // link="/wizard/locatie/start"
                      linkState={{buttonPrev: {new: {onClick: {navigate: '/wizard/welkom/choice_stand_truck_location/'}}}}}
                    />
                  </div>
                  <br/>
                  <ul className="color-grey">
                    <div>Markten</div>
                    <div>Evenementen</div>
                    <div>Winkels</div>
                    <div>Bedrijventerreinen</div>
                  </ul>
                  <br/>
                  <br/>
                </div>
                <div className="item">
                  <img width={70} src={standIcon} alt="Stand, truck, act icon"/>
                  <div className="center">
                    <Button
                      label="Bekijk de stands"
                      link="/?search_model=stand"
                      color="green"
                    />
                  </div>
                  <br/>
                  <ul className="color-grey">
                    <div>Stands, trucks</div>
                    <div>acts</div>
                    <div>mobiele ondernemers</div>
                    <div>ambulante handelaren</div>
                  </ul>
                  <br/>
                  <br/>
                </div>
              </div>
              <div className="footer-buttons">
                <h4>Of, meer informatie voor grote organisaties:</h4>
                <div className="footer-items" style={{justifyContent: "space-evenly"}}>
                  <Button
                    label="Gemeentes"
                    linkOutside="/organisaties/gemeenten-marktmeesters/"
                    color="grey-ghost"
                  />
                  <Button
                    label="Holdings & franchises"
                    linkOutside="/service/contact/"
                    color="grey-ghost"
                  />
                  <Button
                    label="Overige"
                    linkOutside="/service/contact/"
                    color="grey-ghost"
                  />
                </div>
              </div>
            </div>
          </div>
        }/>

      </Wizard>
    </div>
  )
}

export default WizardWelcome
